import { createApp, nextTick } from "vue/dist/vue.esm-bundler.js";
import "../../static/style.css";
import "./pmcc.css";
import "./wheel.css";
import "./wheel-screen.css";
import WheelScreener from "./WheelScreener.vue";
import backtestSnapshot from "./backtest-snapshot.js";

window.__BENEDICT535_BACKTEST_SNAPSHOT__ = backtestSnapshot;

const app = createApp({
  name: "BenedictOptionsWorkspace",
  data() {
    return {
      framework: "Vue 3",
    };
  },
  async mounted() {
    document.documentElement.dataset.frontend = "vue-3";
    await nextTick();
    await import("./pmcc.js");
    await import("./wheel.js");
    createApp(WheelScreener).mount("#wheel-screen-root");
    await import("../../static/app.js");
    document.dispatchEvent(new CustomEvent("benedict535:vue-ready"));
  },
});

app.mount("#app");
